export default "__VITE_ASSET__baa1f9b3__"